import api from '@mint-lib/api';
import { useQuery } from '@mint-lib/query-client';

import { MEDIA_PLAN_VERSIONS } from '../constants/EndpointConstants.js';
import { QueryKey } from '../constants/queryKeys.js';
import { VersionListForTableResponseSchema } from '../types/buyingPlanVersions.js';
import { useSelectedBuyingPlanId } from './useSelectedBuyingPlanId.js';

const getVersionListForTable = async (mediaPlanId: number) => {
  const response = await api.get(`${MEDIA_PLAN_VERSIONS}table_view/`, {
    params: { media_plan_id: mediaPlanId },
  });
  return VersionListForTableResponseSchema.parse(response.data);
};

export const useGetVersionListForTableView = () => {
  const selectedPlanId = useSelectedBuyingPlanId();

  return useQuery({
    queryKey: [QueryKey.GET_VERSION_LIST_FOR_TABLE_VIEW, { selectedPlanId }],
    queryFn: () => getVersionListForTable(selectedPlanId ?? 0),
    enabled: !!selectedPlanId,
  });
};
